module.exports = __webpack_public_path__ + "static/media/Premium-01.24301006.png";